<h1 mat-dialog-title>{{this.input.taskName}} Operator Note</h1>
<div mat-dialog-content>
  <mat-form-field appearance="fill">
    <mat-label>Reason</mat-label>
    <mat-select [(value)]="this.selectedReason" required [disabled]="this.isRemoveMode">
      <mat-option *ngFor="let pair of this.reasonOptions" [value]="pair.value">{{pair.key}}</mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field appearance="fill">
    <mat-label>Operator Note</mat-label>
    <textarea #operatorNote
              matInput rows="6"
              [disabled]="this.isRemoveMode"
              [required]="this.isOperatorNoteRequired"></textarea>
  </mat-form-field>
</div>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close>CANCEL</button>
  <button mat-button
          [disabled]="!this.canSubmit"
          [mat-dialog-close]="this.getResult()">{{ this.isRemoveMode ? 'REMOVE' : 'SAVE' }}</button>
</div>